export default class ProgressBar {


	// Constructor
	constructor(asscroll) {
		this.asscroll = asscroll;
		this.element = document.createElement('div');
		this.element.className = 'progress-bar';
		this.element.setAttribute('aria-hidden', 'true');
		this.bar = document.createElement('div');
		this.element.appendChild(this.bar);
		this.scroll = this.scroll.bind(this);

		this.resize = this.resize.bind(this)

		window.addEventListener('resize', this.resize)
		this.resize()
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.bar;
		delete this.element;
	}
	enable() {
		if (this.element.parentNode !== null) {
			return;
		}
		document.body.appendChild(this.element);
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		if (this.element.parentNode === null) {
			return;
		}
		this.element.parentNode.removeChild(this.element);
		this.asscroll.off('update', this.scroll);
	}


	// Event Handlers
	scroll({ currentPos }) {
		const height = document.body.clientHeight - window.innerHeight;
		const percent = Math.min(1, Math.max(0, currentPos / height));
		this.bar.style.width = (percent * 100) + '%';
	}

	resize() {
		if (window.innerWidth < 768) {
			this.disable()
			this.element.style.display = 'none'
		} else {
			this.element.style.display = 'block'
			this.enable()
		}
	}

}
